import {convertLexicalJsonToHtml} from "./lexical-to-html";
import {stripHtmlToText} from "./strip-html-to-text";

/**
 * Konwertuje JSON z edytora Lexical do czystego tekstu (bez HTML).
 */
export function convertLexicalJsonToPlainText(jsonString: string): string {
    if (!jsonString) return "";
    try {
        const html = convertLexicalJsonToHtml(jsonString);
        return stripHtmlToText(html) ?? "";
    } catch (e) {
        return "";
    }
}


